<template>
  <modal
    :playground="true"
    :title="title"
    @hidden="onHidden"
    class="product-availability-editor"
    ref="modal"
  >
    <product-availability-form
      :disabled="isSubmitting"
      :editable-provider="!isEditing"
      :errors="errors"
      :product="product"
      :values="productAvailability"
      @cancel="hide"
      @submit="upsertProductAvailability"
    />
  </modal>
</template>

<script>
import insertProductAvailability
  from '@/api/mutations/insert-product-availability.graphql';
import Loader from '@/components/Loader';
import Modal from '@/components/Modal';
import Progress from '@/mixins/Progress';
import ProductAvailabilityForm from '@/components/ProductAvailabilityForm';
import Submittable from '@/mixins/Submittable';
import Toast from '@/helpers/Toast';
import updateProductAvailability
  from '@/api/mutations/update-product-availability.graphql';

export default {
  name: 'product-availability-editor',
  mixins: [Progress, Submittable],
  components: {
    Loader,
    Modal,
    ProductAvailabilityForm,
  },
  data() {
    return {
      product: null,
      productAvailability: null,
    };
  },
  computed: {
    title() {
      if (this.isEditing) return this.$t('titles.edit');
      return this.$t('titles.new');
    },
    isEditing() {
      return !!this.productAvailability;
    },
  },
  methods: {
    show(product, availability) {
      this.product = product;
      this.productAvailability = availability;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onHidden() {
      this.product = null;
      this.productAvailability = null;
      this.errors = {};
      this.$emit('hidden');
    },
    async upsertProductAvailability(productAvailability) {
      let operationCallback;
      if (this.isEditing) {
        operationCallback = this.updateProductAvailability;
      } else {
        operationCallback = this.insertProductAvailability;
      }
      const operation = await operationCallback(productAvailability);
      this.$emit('change', operation);
    },
    async insertProductAvailability(productAvailability) {
      const operation = await this.submitWithMutation({
        mutation: insertProductAvailability,
        variables: { productId: this.product.id, productAvailability },
      });
      if (operation.isValid) {
        Toast.success(this.$t('toasts.created'));
        this.hide();
      }
      return operation;
    },
    async updateProductAvailability(productAvailability) {
      const operation = await this.submitWithMutation({
        mutation: updateProductAvailability,
        variables: { id: this.productAvailability.id, productAvailability },
      });
      if (operation.isValid) {
        Toast.success(this.$t('toasts.updated'));
        this.hide();
      }
      return operation;
    },
  },
  i18n: {
    messages: {
      de: {
        titles: {
          new: 'Verfügbarkeit hinzufügen',
          edit: 'Verfügbarkeit bearbeiten',
        },
        toasts: {
          created: 'Verfügbarkeit wurde angelegt.',
          updated: 'Verfügbarkeit wurde aktualisiert.',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductAvailabilityEditor.vue?f902c07a